import React, { Component } from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { connect } from "react-redux";
import DemandPlannerVersionMiddleware from '../../../store/middleware/demandPlannerVersionMiddleware';
import MachineGeneratedVersion from './MachineGeneratedVersion';
import HumanGeneratedVersion from './HumanGeneratedVersion';
import './PopUpModal.styles.scss'



class PopUpModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            isMachineGenerated:true,
            value: '',
            selectedForecast:true,
            versionPage:1,
            versions:[]
        }
    }
  
    handleOpen = () => {
        this.setState({
            isOpen: true
        })
    }
    handleClose = () => {
        this.setState({
            isOpen: false
        })
    }
    handleChange1 = () => {
        this.setState({
            isMachineGenerated: true
        })
    };
    handleChange2 = () => {
        this.setState({
            isMachineGenerated: false
        })
    };

    render() {
        return (
            <div>
                <Modal
                    className='main-pop-up'
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={this.props.isOpen}
                    onClose={this.props.handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={this.props.isOpen}>
                        <div className='pop-up-container' >
                            <div className='pop-up-heading-container'>
                                <h2 id="transition-modal-title" className='pop-up-heading'>Version History</h2>
                            </div>
                            <div className='pop-up-data'>
                                <div className='tab-container'>
                                    <p onClick={this.handleChange1} className={`tab ${this.state.isMachineGenerated?'active-tab':''}`}>Machine Generated Version {this.state.isMachineGenerated?this.props.demandPlannerVersion?`(${this.props.demandPlannerVersion.total_count})`:null:null}</p>
                                    <p onClick={this.handleChange2} className={`tab ${!this.state.isMachineGenerated?'active-tab':''}`}>Human Generated Version {!this.state.isMachineGenerated?this.props.demandPlannerVersion?`(${this.props.demandPlannerVersion.total_count})`:null:null}</p>
                                </div>
                                {this.state.isMachineGenerated
                                ?
                                <MachineGeneratedVersion/>
                                :
                                <HumanGeneratedVersion/>
                                }
                            </div>
                        </div>
                    </Fade>
                </Modal>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        isDemandPlannerVersionLoading:state.DemandPlannerVersionReducer.isDemandPlannerVersionLoading,
        demandPlannerVersion:state.DemandPlannerVersionReducer.demandPlannerVersion
    };
  };
  
  const mapDispatchToprops = dispatch => {
    return {
        getDemandPlannerVersions: (page,selectedForecast) => {
        return dispatch(DemandPlannerVersionMiddleware.getDemandPlannerVersions(page,selectedForecast));
      }
    };
  };
  
  export default connect(mapStateToProps, mapDispatchToprops)(PopUpModal);